import { render } from "./MotorDrivingCourseSummary.vue?vue&type=template&id=cc0aa564&ts=true"
import script from "./MotorDrivingCourseSummary.vue?vue&type=script&lang=ts"
export * from "./MotorDrivingCourseSummary.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\iflam\\OneDrive\\নথিসমূহ\\tms-next\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__